module.exports = "https://img.xiyuyouxi.com/saas/img/shop_item.28182490.png";